export function txtInputNumericRangeValueValidator(minValue, maxValue) {
    return txtInputNumericValidator((value) => {
        if (value < minValue || value > maxValue) {
            return Promise.reject(new Error('Value must be between ' + minValue + ' and ' + maxValue));
        }
        return Promise.resolve();
    });
}
export function txtInputNumericMinValueValidator(minValue) {
    return txtInputNumericValidator((value) => {
        if (value < minValue) {
            return Promise.reject(new Error('Value must not be less than ' + minValue));
        }
        return Promise.resolve();
    });
}
export function txtInputNumericMaxValueValidator(maxValue) {
    return txtInputNumericValidator((value) => {
        if (value > maxValue) {
            return Promise.reject(new Error('Value must not be more than ' + maxValue));
        }
        return Promise.resolve();
    });
}
export function txtInputNumericValidator(numberValidator) {
    return (rule, value, callback) => {
        if (rule.type !== "string") {
            throw new Error("This validator is meant for input type string, consider using numeric input and the antd inbuilt min and max validators");
        }
        if (!value) {
            return Promise.resolve();
        }
        const parsedValue = parseFloat(value);
        if (isNaN(parsedValue) || !isFinite(parsedValue)) {
            return Promise.reject(new Error('Value needs to be a number'));
        }
        return numberValidator(parsedValue);
    };
}
